import galleryImg01 from "../../assets/images/img01.webp";
import galleryImg02 from "../../assets/images/img02.webp";

// import galleryImg04 from "../../assets/images/gal4.jpg";
import galleryImg05 from "../../assets/images/img03.webp";
import galleryImg06 from "../../assets/images/img04.webp";
import galleryImg07 from "../../assets/images/img05.webp";
import galleryImg09 from "../../assets/images/img06.webp";

const galleryImages = [
  galleryImg01,
  galleryImg07,
  galleryImg05,
  galleryImg06,
  galleryImg02,
  galleryImg09,
  
  
];

export default galleryImages;
